import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CModal, CModalHeader, CModalBody, CModalTitle, CButton } from '@coreui/react';
import { BsArrowRight } from 'react-icons/bs';
import Timetable from './timetable'; // Assurez-vous que le composant Timetable est correctement importé
import api from '../../../service/caller'; // Assurez-vous que l'API est correctement importée
import { getUserIdFromToken } from '../../../utils/authUtils';
import choco from '../../../assets/images/choco.png';
import { FaArrowLeft } from "react-icons/fa";
import Select from "react-select";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DoctorSelectionrdv = ({ visible, onClose, }) => {
    const navigate = useNavigate(); // Initialisez useNavigate
    const [doctors, setDoctors] = useState([]);
    const [UserData, setUserData] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [appointmentDate, setAppointmentDate] = useState(null);
    const [appointmentFinalInfo, setAppointmentFinalInfo] = useState(null);
    const [doctorMessage, setDoctorMessage] = useState('');
    const [doctorSchedule, setDoctorSchedule] = useState([]);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [departments, setDepartments] = useState([]);

    const location = useLocation();
    const appointmentInfo = location.state;

    // Accès direct à hospitalId
    const hospitalId = appointmentInfo?.hospitalId;
    const departmentId = appointmentInfo?.appointmentData.department;

    // listes des departments
    useEffect(() => {
        if (!hospitalId) {
            return; // Si hospitalId est undefined ou null, on arrête l'exécution
        }

        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments/hospital/${hospitalId}`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });

                // Mettre à jour les départements dans l'état
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des départements:', error);
                // setMessage('Erreur lors de la récupération des départements.');
            }
        };

        fetchDepartments(); // Appel de la fonction pour récupérer les départements
    }, [hospitalId]); // Dépendance sur hospitalId, la requête sera effectuée dès qu'il est défini

    // les information de l'utilisateur
    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
                setUserRole(response.data.role.name);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    const fetchDoctors = async () => {
        try {
            const response = await api.get(`/api/getDoctorsByDepartment/${departmentId}`);

            console.log('Réponse API médecins:', response);

            if (response.data && response.data.data) {
                setDoctors(response.data.data);
            } else {
                setDoctorMessage("Aucun médecin trouvé pour ce département.");
            }
        } catch (err) {
            console.error('Erreur détaillée:', err);
            setDoctorMessage(`Erreur lors du chargement des docteurs: ${err.message}`);
        }
    };

    // Ajoutez ce useEffect pour appeler fetchDoctors quand departmentId change
    useEffect(() => {
        if (departmentId) {
            fetchDoctors(); // Appel de la fonction pour récupérer les médecins
        }
    }, [departmentId]); // Dépendance sur departmentId

    // doctor id
    const doctorId = selectedDoctor ? selectedDoctor._id : null;

    const fetchDoctorSchedule = async (doctorId) => {
        try {
            const response = await api.get(`/api/schedule/${doctorId}`);
            setDoctorSchedule(response.data.data[0].schedules);
        } catch (error) {
            console.error('Erreur lors de la récupération des horaires du médecin:', error);
        }
    };

    // useEffect(() => {
    //     console.log('État mis à jour:', doctorSchedule);
    // }, [doctorSchedule]);

    useEffect(() => {
        if (doctorId) {
            fetchDoctorSchedule(doctorId);
        }
    }, [doctorId]);

    const handleDoctorSelection = (doctor) => {
        setSelectedDoctor(doctor);
        fetchDoctorSchedule(doctor._id);
    };

    const handleDateChange = (date) => {
        setAppointmentDate(date);
    };

    // Fonction pour calculer l'heure de fin en fonction de la durée dynamique
    const calculateEndTime = (startTime, durationInMinutes) => {
        const start = new Date(`1970-01-01T${startTime}:00Z`);  // On crée une date à partir de l'heure de début
        const end = new Date(start.getTime() + durationInMinutes * 60000);  // Ajoute la durée en minutes
        const endTime = end.toISOString().substr(11, 5);  // Extrait uniquement l'heure et les minutes
        return endTime;
    };


    const handleConfirmAppointment = async (appointmentschedule) => { 
        if (!selectedDoctor || !appointmentschedule) {
            alert('Veuillez sélectionner un médecin et une date.');
            return;
        }

        const appointmentDuration = appointmentschedule.durationApt || 30;
        const calculateappointmentEndTime = calculateEndTime(appointmentschedule.time, appointmentDuration);

        const appointmentData = {
            doctorId: doctorId,
            patientId: appointmentInfo.appointmentData.patientId,
            motif: appointmentInfo.appointmentData.motif,
            department: appointmentInfo.appointmentData.department,
            price: appointmentInfo.appointmentData.price,
            notes: appointmentInfo.appointmentData.notes,
            type_consultation: appointmentschedule.type === 'camera' ? 'online' : (appointmentschedule.type === 'person' ? 'inperson' : ''),
            appointmentDate: appointmentschedule.date,
            appointmentTime: appointmentschedule.time,
            appointmentEndTime: calculateappointmentEndTime,
        }

        const dataAppointment = {
            hospitalId,
            appointmentData
        };

        try {
            const response = await api.post('/clinic/createBaseAppointment', dataAppointment); // Cette ligne va maintenant attendre la réponse de l'API
            setAppointmentFinalInfo(response.data.appointment);
            setShowSuccessModal(true);

            const paymentData = {
                operationtype: 'Appointment Consultation',
                OperationId: response.data.appointment._id,
                operationcode: response.data.appointment.AppointmentCode,
                paymentuniqueId: response.data.appointment.paymentuniqueId,
                caissiereId: getUserIdFromToken(),
                patientId: response.data.appointment.patientId,
                amount: response.data.appointment.price,
                currency: 'FCFA',
                purpose: 'Consultation Fee',
                department: response.data.appointment.department,
            };

            // Appel de la deuxième API pour le paiement
            const paymentResponse = await api.post('/clinic/createPayment', paymentData);
            const billingID = paymentResponse.data.billing._id;

            if (userRole === "medtinz_client_patient" && billingID) {
                navigate(`/Billings/invoiceAssurance/${billingID}`, {
                    state: { billingID },
                });
            } else {
                setShowSuccessModal(true);
            }
        } catch (error) {
            console.error('Error adding appointment:', error);
            alert('Failed to add appointment', error);
        }
    };


    // fermer le modal de succes
    const handleCloseSuccessModal = () => {
        // Rediriger vers la page de la liste des rendez-vous en cours
        navigate('/hospitaladmin/Appointmentlist');
    };



    return (
        <CModal className='newregistermodal xl'
            alignment="center"
            scrollable
            size='xl'
            visible={true}
            onClose={onClose}
            aria-labelledby="schedulemodal">
            <CModalHeader>
                <CModalTitle id="schedulemodal" className='Titleformsmodal'>Register New Appointment</CModalTitle>
            </CModalHeader>
            <CModalBody>
                <div className='doctorselect'>
                    <div className="retourbtn">
                        <CButton className="retourbtn" onClick={() => (navigate(-1) || navigate('/'))}>
                            <FaArrowLeft /> Retour
                        </CButton>
                    </div>
                    {doctorMessage && <p>{doctorMessage}</p>}
                    <div className="form-group">
                        <label htmlFor="doctor">Doctor</label>
                        <Select
                            name="doctorId"  // Ajout de l'attribut name
                            options={doctors.map((doctor) => ({
                                value: doctor._id, // Id du médecin pour identification
                                label: `${doctor.lastname} ${doctor.firstname}` // Nom et prénom du médecin
                            }))}
                            value={selectedDoctor ? { value: selectedDoctor._id, label: `${selectedDoctor.lastname} ${selectedDoctor.firstname}` } : null}
                            onChange={(selectedOption) => {
                                // Lorsqu'une option est sélectionnée, mettre à jour selectedDoctor
                                const doctor = doctors.find(d => d._id === selectedOption.value);
                                setSelectedDoctor(doctor);
                                fetchDoctorSchedule(doctor._id); // Charger l'emploi du temps du médecin
                            }}
                            placeholder="Select a doctor"
                        />
                    </div>

                    {selectedDoctor && doctorSchedule.length > 0 && (
                        <div>
                            <p>
                                Doctor <strong>Dr. {selectedDoctor.lastname} {selectedDoctor.firstname} </strong> timetable:
                            </p>
                            <Timetable doctorSchedule={doctorSchedule} onAppointmentSaved={handleConfirmAppointment} doctorId={selectedDoctor._id} />
                        </div>
                    )}

                    {selectedDoctor && doctorSchedule.length === 0 && (
                        <div>
                            <p>Aucune disponibilité pour ce médecin.</p>
                        </div>
                    )}

                    <div className="savenewuser form-group d-flex justify-content-center">
                        <CButton type="submit" onClick={handleConfirmAppointment}>
                            Save Appointment &nbsp; <BsArrowRight />
                        </CButton>
                    </div>
                </div>
            </CModalBody>

            <div className='timetablelast'>
                {/* Deuxième Modal */}
                {showSuccessModal && (
                    <div className="modal-overlay">
                        <div className="modal-content2">
                            <div className="text-center vie">
                                <h2 className="text-lg semibold mb-4">SUCCESS</h2>
                            </div>

                            <div className="immole">
                                <div className="text-start">
                                    <p><strong>Rdv Enregistre avec success</strong> </p>
                                    <p>Veuillez passer a la caisse avec ce numero<strong style={{ color: 'green' }}> {appointmentFinalInfo?.paymentuniqueId}</strong> pour effectuer votre payement</p>
                                    <p><strong>Appointment Code:</strong> {appointmentFinalInfo?.AppointmentCode}</p>
                                    <p><strong>Patient ID:</strong> {appointmentFinalInfo?.patient_Name}</p>
                                    <p><strong>Motif:</strong> {appointmentFinalInfo?.motif}</p>
                                    <p><strong>Type Consultation:</strong> {appointmentFinalInfo?.type_consultation}</p>
                                    <p><strong>Department:</strong> {
                                        // Find the department name based on the department ID
                                        departments.find(department => department._id === appointmentFinalInfo.department)?.name || 'N/A'
                                    }</p>
                                    <p><strong>Price:</strong> {appointmentFinalInfo?.price} FCFA</p>
                                    <p><strong>Notes:</strong> {appointmentFinalInfo?.notes}</p>

                                </div>
                                <div>
                                    <img src={choco} alt="choco" className="choco" />
                                </div>
                            </div>

                            <div className="mt-4">
                                <button
                                    className="modal-button2 confirm mx-auto"
                                    onClick={handleCloseSuccessModal}
                                >
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                )
                }
            </div>
        </CModal>
    );
};

export default DoctorSelectionrdv;
